export class Question {
    getComponent(): string {
        return 'EmptyLoad';
    }

    getData(): object {
        return this;
    }
}